import type { FormulaDisabledDocEntityBase } from "building-types/entities/docEntityBase";
import type { LabelableEntityBase } from "building-types/entities/labelTypes";
import type { HorizontalFloorAssemblyType } from "building-types/floors/floorAssemblyTypes";
import { SpanDirection, type StructuralFloorType } from "building-types/floors/floorComponentsTypes";
import type { FloorAssemblyFinishLayer, FloorFinish } from "building-types/floors/floorFinishTypes";
import type { FramingOverrideFields } from "building-types/floors/floorSplitDataTypes";
import type { FloorSystemOpeningFramingConfig } from "building-types/floors/floorSystemOpeningFramingTypes";
import type { Floor, FloorPath } from "building-types/floors/floorTypes";
import type { DocForeignKeyTable } from "../doc/docForeignKeyTable";
import type { PrimaryEntityId } from "../doc/primaryEntityId";
import type { ForeignEntityId } from "../handles/foreignEntityId";

export type HalfEdgeToFloorPath = { [halfEdgeIndex: number]: FloorPath };
export type FloorFinishAssemblyTable = DocForeignKeyTable<"ROOM", FloorAssemblyFinishLayer[]>;
export type FloorFinishTable = DocForeignKeyTable<"ROOM", FloorFinish[]>;

export interface FloorSystem {
  readonly levelId: ForeignEntityId<"LEVEL">;
  readonly roomClassFloors: Floor[][]; // indexed by roomClass
  readonly roomFloorFinishes: FloorFinishTable;
}

export interface FloorSystemExternal
  extends FormulaDisabledDocEntityBase<"FLOOR_SYSTEM">,
    LabelableEntityBase,
    FramingOverrideFields {
  readonly id: PrimaryEntityId<"FLOOR_SYSTEM">;
  readonly horizontalAssemblyType: HorizontalFloorAssemblyType;
  readonly structuralType: StructuralFloorType;
  readonly lateralOffset?: number;
  readonly topDatum?: ForeignEntityId<"DATUM">;
  readonly openingFramingConfig?: FloorSystemOpeningFramingConfig;
}

export const defaultFloorSystemFramingValues: Pick<FloorSystemExternal, "spanDirection" | "framingAngle"> = {
  spanDirection: SpanDirection.SPECIFY,
  framingAngle: 90,
};
